import { RouteRecordRaw } from 'vue-router';

import { useFeatureFlags } from 'SharedDir/common/composables/useFeatureFlags';
import { FeatureFlagName } from 'SharedDir/declarations/system/region-customization';
import { authorizedOnly } from 'SharedDir/router/helpers';
import { requireAnyPermissions } from 'SharedDir/router/permission-guard';
import permissionSet from 'SharedDir/service/permissions/PermissionSet';

const Index = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Profile/pages/Index.vue');

const ProfileIndex = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Profile/pages/Profile.vue');

const ProfileChangePassword = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Profile/pages/ChangePassword.vue');

const DocumentsIndex = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Profile/pages/Documents.vue');

const OrganizationsIndex = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Profile/pages/Organizations.vue');

const Issues = () =>
  import(/* webpackChunkName: "IssueList" */ 'PortalDir/modules/Profile/pages/Issues.vue');

const Notifications = () =>
  import(
    /* webpackChunkName: "NotificationList" */'PortalDir/modules/Profile/pages/Notifications.vue'
  );

const Certificates = () =>
  import(/* webpackChunkName: "Certificates" */ 'PortalDir/modules/Profile/pages/Certificates.vue');

const Empty = () => import(/* webpackChunkName: "Empty" */ 'SharedDir/layouts/Empty.vue');

const profileChildren: RouteRecordRaw[] = [
  {
    path: 'profile',
    name: 'profile',
    component: ProfileIndex,
  },
  {
    path: 'change-password',
    name: 'profile-change-password',
    component: ProfileChangePassword,
  },
  {
    path: 'organizations',
    name: 'profile-organizations',
    component: OrganizationsIndex,
  },
  // {
  //   path: 'documents',
  //   name: 'profile-documents',
  //   component: DocumentsIndex,
  // },
  {
    path: 'issues',
    name: 'profile-issues',
    component: Issues,
  },
  {
    path: 'dialog',
    name: 'profile-dialog',
    component: Empty,
  },
  {
    path: 'notifications',
    name: 'profile-notifications',
    component: Notifications,
  },
];

if (useFeatureFlags().isFeatureEnabled(FeatureFlagName.HasMyCertificates)) {
  profileChildren.push({
    path: 'certificates',
    name: 'profile-certificates',
    // Certificates.vue тянет cadesplugin: UMD читает window при загрузке модуля, SSR отдаёт 500.
    // На сервере страницу не монтируем — контент собирается только в браузере.
    component: typeof window === 'undefined' ? Empty : Certificates,
    beforeEnter: requireAnyPermissions(
      permissionSet.userCertificate.list,
      permissionSet.userCertificate.listAll
    ),
  });
}

export default [
  {
    path: '',
    name: 'profile-index',
    component: Index,
    meta: authorizedOnly(),
    children: profileChildren,
  },
];
